import { RouteConfig } from 'vue-router';

export const routes: RouteConfig[] = [
  {
    path: 'tippspiel',
    component: () => import('./views/TippspielView.vue'),
    meta: { title: 'WM Tippspiel' },
  },
]
